import { render, staticRenderFns } from "./PackageListCard.vue?vue&type=template&id=0bb64152&scoped=true"
import script from "./PackageListCard.vue?vue&type=script&lang=js"
export * from "./PackageListCard.vue?vue&type=script&lang=js"
import style0 from "./PackageListCard.vue?vue&type=style&index=0&id=0bb64152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb64152",
  null
  
)

export default component.exports